import * as React from 'react';
import Typography from '@material-ui/core/Typography';
import { Form } from 'react-final-form';
import { TextField } from 'mui-rff';
import * as Yup from 'yup';
import { IconButton, InputAdornment, SnackbarContent } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import { Link as RouterLink } from 'react-router-dom';
import Container from '@material-ui/core/Container';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import { setIn } from 'final-form';
import { useStyles } from './css';

export function DeveloperLoginView({ onSubmit, error, loading }) {
    const classes = useStyles();
    const [showPassword, setShowPassword] = React.useState(false);

    const validate = schema => {
        // eslint-disable-next-line consistent-return
        return async values => {
            if (typeof schema === 'function') {
                schema = schema();
            }

            try {
                await schema.validate(values, { abortEarly: false });
            } catch (e: any) {
                return e.inner.reduce((errors, validationError) => {
                    return setIn(errors, validationError.path, validationError.message);
                }, {});
            }
        };
    };

    return (
        <Container
            component="main"
            maxWidth="xs"
            style={{ paddingTop: '60px', paddingBottom: '60px' }}
        >
            <div className={classes.paper}>
                <Typography component="h1" variant="h5">
                    Bókun Partner Login
                </Typography>

                <Form
                    initialValues={{
                        email: '',
                        password: '',
                    }}
                    validate={validate(
                        Yup.object().shape({
                            email: Yup.string()
                                .email('Email is invalid')
                                .required('Email is required'),
                            password: Yup.string().required('Password is required'),
                        })
                    )}
                    onSubmit={onSubmit}
                >
                    {({ pristine, handleSubmit }) => (
                        <form className={classes.form} onSubmit={handleSubmit} noValidate>
                            <TextField
                                type="email"
                                variant="outlined"
                                required
                                fullWidth
                                id="email"
                                label="Email Address"
                                name="email"
                                autoFocus
                                margin="normal"
                            />
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                name="password"
                                label="Password"
                                type={showPassword ? 'text' : 'password'}
                                id="password"
                                margin="normal"
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                onClick={() => setShowPassword(!showPassword)}
                                            >
                                                {showPassword ? (
                                                    <VisibilityIcon />
                                                ) : (
                                                    <VisibilityOffIcon />
                                                )}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />

                            {error && (
                                <SnackbarContent
                                    className={classes.error}
                                    message={error && error.message}
                                />
                            )}

                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="primary"
                                size="large"
                                className={classes.submit}
                                disabled={pristine || loading}
                            >
                                {loading ? (
                                    <CircularProgress size={24} />
                                ) : (
                                    <React.Fragment>Log in</React.Fragment>
                                )}
                            </Button>
                        </form>
                    )}
                </Form>

                <Grid container>
                    <Grid item xs>
                        <Link href="#" variant="body2">
                            Forgot password?
                        </Link>
                    </Grid>
                    <Grid item>
                        <Link variant="body2" component={RouterLink} to="/developer/signup">
                            {"Don't have an account? Sign Up"}
                        </Link>
                    </Grid>
                </Grid>
            </div>
        </Container>
    );
}
